var _circle, _path, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottleCompleteIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 70,
    viewBox: "0 0 65 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5004,
    cy: 11.7507,
    r: 3.12813,
    fill: "#0094FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0606 18.8576V18.0068H29.9418V18.8576H29.3731V20.8427H29.9418V31.4772C28.9939 32.2807 26.8706 34.3131 25.9606 36.0146V68.4854C26.008 68.6744 26.1881 69.0809 26.5293 69.1943H38.4731C38.8143 69.0809 38.9944 68.6744 39.0418 68.4854V36.0146C38.1318 34.3131 36.0085 32.2807 35.0606 31.4772V20.8427H35.6293V18.8576H35.0606Z",
    fill: "url(#paint0_linear_594_45304)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5005,
    cy: 17.1694,
    r: 14.2188,
    transform: "rotate(0.0569805 32.5005 17.1694)",
    stroke: "url(#paint1_linear_594_45304)",
    strokeWidth: 2.84375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_45304",
    x1: 32.5012,
    y1: 62.6537,
    x2: 32.5012,
    y2: 32.7943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_594_45304",
    x1: 32.4933,
    y1: 10.2022,
    x2: 32.5158,
    y2: 32.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleCompleteIllustration);
export default __webpack_public_path__ + "static/media/bottle-complete-illustration.457a5898637dfd1babf272d4ea81ce48.svg";
export { ForwardRef as ReactComponent };